import * as constants from '../../constants';
import newScoreBar from './score-bar';

const whiteText = {
  font: '15px Open Sans, Arial',
  fill: 0xFFFFFF,
};

const cols = 2;
const spacing = 1;

const panelWidth = constants.screenWidth / cols;
export const panelHeight = 70;

const panelInnerWidth = panelWidth - 2 * spacing;
const panelInnerHeight = panelHeight - 2 * spacing;
const panelScorebarWidth = 110;

export const resultPanel = function ( test, timestable ) {
  const score = test.scoreForTimestable(timestable);

  const c = new PIXI.Container();
  const g = new PIXI.Graphics();
  g.beginFill(constants.mediumBlue).drawRect(spacing, spacing, panelInnerWidth, panelInnerHeight).endFill();
  c.addChild(g);

  if ( typeof timestable === 'undefined' ) {
    return c;
  }

  const titleText = new PIXI.Text(`${ timestable } TIMES TABLE`, whiteText);
  const scoreText = new PIXI.Text(`${ score.correct }/${ score.total }`, whiteText);
  const scoreBar = newScoreBar(panelScorebarWidth, 10, score.correct, score.total);

  const scorebarX = ( panelWidth - panelScorebarWidth ) / 2;

  titleText.anchor.set(0.5, 0);
  titleText.position.set(panelWidth / 2, 15);
  
  scoreText.anchor.set(1, 0.5);
  scoreText.position.set(scorebarX - 5, 45);

  scoreBar.anchor.set(0, 0.5);
  scoreBar.position.set(scorebarX, 45);

  [ titleText, scoreText, scoreBar ].forEach(elm => c.addChild(elm));

  return c;
};
